import { tracked } from '@glimmer/tracking';

import type { APIData } from 'webapp-types';

import MetricLimitationBase from 'webapp/models-custom/metric-limitation/base';
import MetricLimitationCumulative from 'webapp/models-custom/metric-limitation/cumulative';

// for more general info check MetricLimitationBase

export interface GranulationRawData extends APIData.Metrics.GranulationLimitation {
	unsupportedBaseConstraint?: boolean; // set by webapp when the base constraints don't allow it
}

export default class MetricLimitationGranularity extends MetricLimitationBase<GranulationRawData> {
	override childLimitations: MetricLimitationCumulative[] = [];

	@tracked override isParentDisabled = false;

	constructor(id: string, rawData?: GranulationRawData, isParentDisabled = false) {
		super(id, rawData, isParentDisabled);
		this.createChildLimitations();
	}

	get disabled(): boolean {
		let disabled = false;

		if (this.isParentDisabled) {
			disabled = true;
		} else if (this.rawData) {
			disabled = !!this.rawData.disabled;

			if (!disabled) {
				disabled = !!this.childLimitations?.[0]?.disabled;
			}
		}

		return disabled;
	}

	get infoText(): string {
		let infoText = '';
		if (this.rawData?.info?.message) {
			infoText = this.rawData.info.message;
			// } else {
			// 	infoText = this.childLimitations[0]?.infoText;
			// } else if (this.isParentDisabled) {
			// 	infoText = 'Date range not available';
		}
		return infoText;
	}

	// true when this granulation is not supported because of base constraints
	get unsupportedBaseConstraint(): boolean {
		return !!this.rawData?.unsupportedBaseConstraint;
	}

	createChildLimitations(): void {
		const childLimitations: MetricLimitationCumulative[] = [];

		// creating cumulative limitation (only one)

		if (this.rawData) {
			childLimitations.push(
				new MetricLimitationCumulative(
					'cumulative',
					this.rawData?.variations,
					this.isParentDisabled,
				),
			);
		}

		this.childLimitations = childLimitations;
	}
}
